import { render } from "./our_skill.vue?vue&type=template&id=45d69007&scoped=true"
import script from "./our_skill.vue?vue&type=script&lang=js"
export * from "./our_skill.vue?vue&type=script&lang=js"

import "./our_skill.vue?vue&type=style&index=0&id=45d69007&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d69007"]])

export default __exports__